<script lang="ts">
    import cn from 'classnames';
    import s from './font.module.css';
    import type { Props } from './types';
    import { TagName, Color } from './types';

    export let tagName: Props['tagName'] = TagName.div;
    export let type: Props['type'] = null;
    export let isBold: Props['isBold'] = false;
    /**
     * @deprecated use 'classes' instead
     * */
    export let className: Props['className'] = '';
    export let classes: Props['className'] = '';
    export let attrs: Props['attrs'] = {};
    export let el: Props['el'] = null;
    export let style: Props['style'] = null;
    export let slot: Props['slot'] = null;
    export let color: Props['color'] = Color.Primary;
    export let title: Props['title'] = null;

    $: rootClass = type ? `${type}${isBold ? '-bold' : ''}` : null;
</script>

<svelte:element
    this={tagName}
    class={cn(rootClass && s[rootClass], !rootClass && isBold && s.bold, color && s[color], className, classes)}
    on:click
    bind:this={el}
    {style}
    {title}
    data-testid="font-container"
    {...attrs}
>
    <slot>{@html slot}</slot>
</svelte:element>
